<div
  class="fixed z-50 m-2 border bg-white shadow-sm sm:rounded-sm"
  [style.top.px]="top - 8"
  [style.left.px]="left + 90"
>
  <div class="max-w-2xl p-1 tooltip-arrow-left">
    <img class="w-96" src="/images/compliance/pmi/IMG_2983.jpg" />
  </div>
</div>
